// Piezas que comparten Ingresar, Crear cuenta y Recuperar clave.
import React, { useEffect, useRef, useState } from "react";
import { FormFeedback, Input } from "reactstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import { apiError, socialLogin } from "../../store/actions";

const GOOGLE_ERROR = "No pudimos entrar con Google. Vuelve a intentarlo.";

// Botón oficial de Google, a todo el ancho de su contenedor. Google lo dibuja
// en un iframe y sólo acepta el ancho en píxeles (entre 200 y 400), así que
// hay que medir el contenedor.
export const GoogleButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const holder = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const measure = () => {
      if (!holder.current) return;
      setWidth(Math.max(200, Math.min(400, Math.floor(holder.current.offsetWidth))));
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  const onSuccess = ({ credential }) => {
    try {
      const decoded = jwtDecode(credential);
      const postData = {
        name: decoded.name,
        email: decoded.email,
        token: credential,
      };
      dispatch(socialLogin(postData, navigate, "google"));
    } catch (error) {
      console.error("Error en Google Response:", error);
      dispatch(apiError(GOOGLE_ERROR));
    }
  };

  return (
    <div ref={holder} className="d-flex justify-content-center" style={{ minHeight: 40 }}>
      {width > 0 && (
        <GoogleLogin
          onSuccess={onSuccess}
          onError={() => dispatch(apiError(GOOGLE_ERROR))}
          text="continue_with"
          size="large"
          logo_alignment="center"
          locale="es"
          width={width}
        />
      )}
    </div>
  );
};

// Aviso que aparece cuando el email escrito es de Gmail: ocupa el lugar del
// campo de clave y ofrece el botón de Google ahí mismo, donde el usuario está
// mirando. `onSkip` es la salida para quien igual quiere usar una clave.
export const GmailNotice = ({ title, children, skipLabel, onSkip }) => (
  <div
    style={{
      background: "#eef6ff",
      border: "1px solid #c9defa",
      borderRadius: 10,
      padding: 14,
    }}
  >
    <div className="d-flex align-items-start mb-3">
      <span
        className="material-symbols-rounded me-2"
        style={{ fontSize: 22, color: "#1a73e8" }}
      >
        info
      </span>
      <div style={{ fontSize: 14, color: "#333" }}>
        <div style={{ fontWeight: 700 }}>{title}</div>
        <div>{children}</div>
      </div>
    </div>
    <GoogleButton />
    {onSkip ? (
      <div className="text-center mt-2">
        <button
          type="button"
          className="btn btn-link text-muted p-0"
          style={{ fontSize: 13 }}
          onClick={onSkip}
        >
          {skipLabel}
        </button>
      </div>
    ) : null}
  </div>
);

// Campo de clave con el botón para verla: en un teléfono es fácil equivocarse
// de tecla, y sin verla no hay forma de darse cuenta.
export const PasswordInput = ({ validation, placeholder, autoComplete }) => {
  const [visible, setVisible] = useState(false);
  const invalid = validation.touched.password && validation.errors.password ? true : false;

  return (
    <div style={{ position: "relative" }}>
      <Input
        name="password"
        value={validation.values.password || ""}
        type={visible ? "text" : "password"}
        placeholder={placeholder}
        autoComplete={autoComplete}
        // backgroundImage: el ícono de error de Bootstrap caería debajo del ojo.
        style={{ borderRadius: 8, padding: "10px 46px 10px 14px", backgroundImage: "none" }}
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        invalid={invalid}
      />
      <button
        type="button"
        onClick={() => setVisible(!visible)}
        title={visible ? "Ocultar la clave" : "Ver la clave"}
        aria-label={visible ? "Ocultar la clave" : "Ver la clave"}
        style={{
          position: "absolute",
          top: 4,
          right: 6,
          height: 36,
          width: 36,
          border: "none",
          background: "transparent",
          color: "#74788d",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span className="material-symbols-rounded" style={{ fontSize: 20 }}>
          {visible ? "visibility_off" : "visibility"}
        </span>
      </button>
      {invalid ? (
        <FormFeedback type="invalid">
          <div>{validation.errors.password}</div>
        </FormFeedback>
      ) : null}
    </div>
  );
};
